import { Button } from '@/src/components/Commons/Button';
import NumberInput from '@/src/components/Commons/Controllers/NumberInput/NumberInput';
import { TaskComponentProps, TxComponentProps } from '@/src/types/index';
import { TOKEN_GOV_DECIMALS, TOKEN_GOV_TN_STR } from '@/src/utils/constants';
import { TOKEN_ADA_DECIMALS } from '@/src/lib/SmartDB/Commons/Constants/constants';
import { ROUTES } from '@/src/utils/routes';
import { useRouter } from '@/src/store/router/RouterProvider';
import TxProcessing from '../../TxProcessing';
import styles from './GetTokenGovTx.module.scss';
import useGetTokenGovTx from './useGetTokenGovTx';

export default function GetTokenGovTx({ ...props }: {} & TxComponentProps & TaskComponentProps) {
    //--------------------------------------
    const router = useRouter();
    //--------------------------------------
    const {
        appStore,
        isRefreshing,
        isProcessingTx,
        isFaildedTx,
        setIsFaildedTx,
        isConfirmedTx,
        setIsConfirmedTx,
        processingTxMessage,
        processingTxHash,
        isValidTx,
        amount,
        setAmount,
        handleBtnGetTokenGovTx,
    } = useGetTokenGovTx({ ...props });
    //--------------------------------------
    return (
        <>
            {isProcessingTx || isConfirmedTx || isFaildedTx ? (
                <>
                    <TxProcessing
                        isProcessingTx={isProcessingTx}
                        processingTxMessage={processingTxMessage}
                        processingTxHash={processingTxHash}
                        isFaildedTx={isFaildedTx}
                        setIsFaildedTx={setIsFaildedTx}
                        isConfirmedTx={isConfirmedTx}
                        setIsConfirmedTx={setIsConfirmedTx}
                        onFinishTask={props.onFinishTask}
                        showNewTransactionButton={true}
                        nameForNewTransactionButton={`Get more ${TOKEN_GOV_TN_STR}`}
                        nameForCloseButton="Close"
                        othersButtonsWhenConfirmed={
                            <>
                                <Button
                                    mode="action"
                                    size="large"
                                    width={200}
                                    onClick={async () => {
                                        await router.push({
                                            pathname: ROUTES.PORTFOLIO,
                                        });
                                    }}
                                >
                                    View Portfolio
                                </Button>
                            </>
                        }
                    />
                </>
            ) : (
                <>
                    <table className={styles.tableFormModal}>
                        <thead>
                            <tr>
                                <th colSpan={2}>Get {TOKEN_GOV_TN_STR}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Amount</td>
                                <td>
                                    <NumberInput decimals={TOKEN_GOV_DECIMALS} value={amount} setValue={(value) => setAmount(value)} />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <div className={styles.buttonsBelowForm}>
                                        <Button
                                            mode="action"
                                            size="large"
                                            onClick={() => {
                                                handleBtnGetTokenGovTx();
                                            }}
                                            disabled={!isValidTx}
                                        >
                                            Confirm
                                        </Button>
                                        <Button mode="action" size="large" onClick={props.onCancel}>
                                            Cancel
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </>
            )}
        </>
    );
    //--------------------------------------
}
